import { render, staticRenderFns } from "./classdetailtabs.vue?vue&type=template&id=402dfdbc&scoped=true"
import script from "./classdetailtabs.vue?vue&type=script&lang=js"
export * from "./classdetailtabs.vue?vue&type=script&lang=js"
import style0 from "./classdetailtabs.vue?vue&type=style&index=0&id=402dfdbc&prod&lang=less&scoped=true"
import style1 from "./classdetailtabs.vue?vue&type=style&index=1&id=402dfdbc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402dfdbc",
  null
  
)

export default component.exports